import Swiper, { Navigation, Pagination, Keyboard, Autoplay, A11y, EffectFade } from "swiper";

const sliderwero = new Swiper(".sliderwero", {
	modules: [Navigation, Pagination, Keyboard, A11y],
	loop: true,
	centeredSlides: true,
	slidesPerView: 1,
	spaceBetween: 20,
	preloadImages: true,
	threshold: 10,
	a11y: {
		enabled: true,
		prevSlideMessage: 'Vorheriger Slide',
		nextSlideMessage: 'Nächster Slide',
		firstSlideMessage: 'Dies ist der erste Slide',
		lastSlideMessage: 'Dies ist der letzte Slide',
		paginationBulletMessage: 'Gehe zu Slide {{index}}',
		slideLabelMessage: 'Slide {{index}} / {{slidesLength}}',
	},
	keyboard: {
		enabled: true,
		onlyInViewport: true,
	},
	pagination: {
		el: ".sliderwero__pagination",
		clickable: true,
	},
	navigation: {
		nextEl: ".sliderwero__next",
		prevEl: ".sliderwero__prev",
	}
});

const sliderbankingapp = new Swiper(".sliderbankingapp", {
	modules: [Navigation, Pagination, Keyboard, A11y],
	loop: true,
	centeredSlides: true,
	slidesPerView: 1,
	spaceBetween: 20,
	preloadImages: true,
	threshold: 10,
	a11y: {
		enabled: true,
		prevSlideMessage: 'Vorheriger Slide',
		nextSlideMessage: 'Nächster Slide',
		firstSlideMessage: 'Dies ist der erste Slide',
		lastSlideMessage: 'Dies ist der letzte Slide',
		paginationBulletMessage: 'Gehe zu Slide {{index}}',
		slideLabelMessage: 'Slide {{index}} / {{slidesLength}}',
	},
	keyboard: {
		enabled: true,
		onlyInViewport: true,
	},
	pagination: {
		el: ".sliderbankingapp__pagination",
		clickable: true,
	},
	navigation: {
		nextEl: ".sliderbankingapp__next",
		prevEl: ".sliderbankingapp__prev",
	}
});

const sliderlogo = new Swiper(".sliderlogo", {
	modules: [Navigation, Pagination, Keyboard, Autoplay, EffectFade],
	loop: true,
	centeredSlides: true,
	slidesPerView: 1,
	spaceBetween: 20,
	preloadImages: true,
	threshold: 10,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
	autoplay: {
		delay: 2500,
		disableOnInteraction: false,
	}
});